// extracted by mini-css-extract-plugin
export default {"container":"MPIDItem_container__LG5MD","mpid":"MPIDItem_mpid__mINE6","applicationName":"MPIDItem_applicationName__-TQGs"};